export const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];


export const getDay = (date, fullDate) => {
  const d = new Date(
    fullDate.getFullYear(),
    fullDate.getMonth(),
    date
  );
  return weekDays[d.getDay()];
};

  export const convertedMonthArr = (month, disabled, currentMonth, currentDate) => month?.map((date, i) => {
    return currentMonth ? {
      date,
      disabled : currentDate > i+1,
    } : {  
      date,
      disabled
    }
  })

  // export const filterWeek = (data, selectWeek) => {
  //   switch (selectWeek) {
  //     case "1":
  //       return data.slice(0, 7);
  //     case "2":
  //       return data.slice(7, 14);
  //     case "3":
  //       return data.slice(14, 21);
  //     case "4":
  //       return data.slice(21, 28);
  //       case "5":
  //         return data.slice(28, 35);
  //     default:
  //       return data.slice(35);
  //   }
  // };

export const filterWeek = (data, selectWeek) => {
  const weekIndex = Number(selectWeek) - 1;
  const start = weekIndex * 7;
  const end = start + 7;
  return data.slice(start, end);
};


  export const selectedMonthArr = (days) => Array.from(
    { length: days },
    (_, i) => i + 1
  );


 export const getDropDownlist = (finalMonthArr, fullDate) => {
  const selectDropDown = [];

  const year = fullDate.getFullYear();
  const month = fullDate.getMonth(); // 0-based
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // how many rows calendar actually has
  const totalWeeks = Math.ceil(finalMonthArr.length / 7);

  // 🔑 SPECIAL RULE: February → ONLY 4 weeks
  // const weeksToShow =
  //   month === 1 ? 4 : totalWeeks; // month === 1 → Feb

  const weeksToShow = totalWeeks;

  for (let i = 1; i <= weeksToShow; i++) {
    selectDropDown.push({
      id: i,
      value: `Week ${i}`,
    });
  }

  return selectDropDown;
};




 export const availability = () => {
  const subscriptionForOptions = [
    {
      name: "Full Day",
      value: 0,
    },
    {
      name: "First Half",
      value: 1,
    },
    {
      name: "Second Half",
      value: 2,
    },
    {
      name: "Custom",
      value: 3,
    },
  ];
  return subscriptionForOptions
 }
  